(function(){
  var bag=document.querySelector('[data-bag]');
  var drawer=document.querySelector('[data-drawer]');
  var shade=document.querySelector('[data-shade]');
  var body=document.querySelector('[data-lines]');
  var goal=20000;
  var compareCache={};
  var paintGen=0;
  function money(cents){return '\u20aa'+Math.round((cents||0)/100);}
  function setCount(n){
    if(!bag) return;
    var span=bag.querySelector('span');
    if(!n){ if(span) span.remove(); return; }
    if(!span){ span=document.createElement('span'); bag.appendChild(span); }
    span.textContent=String(n);
  }
  function rateOf(title){
    var head=String(title||'').split('-')[0];
    if(head.indexOf('\u05e1\u05d8')!==-1) return '\u221215%';
    if(head.indexOf('\u05d8\u05d5\u05e4')!==-1 || head.indexOf('\u05d8\u05d9\u05d9\u05e5')!==-1) return '\u22127.5%';
    return '';
  }
  function priceHtml(item){
    var sale=item.final_line_price||0;
    var qty=item.quantity||1;
    var unit=item.compare_at_price;
    var cached=compareCache[item.handle];
    if(unit==null && cached) unit=cached[item.variant_id];
    var unitSale=item.final_price||item.price||0;
    var was=(unit && unit>unitSale) ? unit*qty : 0;
    var saleN=Math.round(sale/100);
    var wasN=Math.round(was/100);
    var offN=wasN-saleN;
    if(offN>0){
      var pct=rateOf(item.product_title);
      return '<p class="cart-price"><s class="was">\u20aa'+wasN+'</s> <span class="hot">\u20aa'+saleN+'</span>'+(pct?' <span class="off" dir="ltr">'+pct+'</span>':'')+'</p>';
    }
    return '<p>'+money(sale)+'</p>';
  }
  function render(cart){
    var total=document.querySelector('[data-total]');
    if(total) total.textContent=money(cart.total_price);
    setCount(cart.item_count||0);
    var checkout=document.querySelector('[data-checkout]');
    if(checkout) checkout.hidden=!(cart.item_count);
    if(!body) return;
    var left=goal-(cart.total_price||0);
    var pct=Math.max(0, Math.min(100, Math.round(((cart.total_price||0)/goal)*100)));
    var note=left>0 ? ('\u05e2\u05d5\u05d3 '+money(left)+' \u05dc\u05de\u05e9\u05dc\u05d5\u05d7 \u05d0\u05e7\u05e1\u05e4\u05e8\u05e1 \u05d7\u05d9\u05e0\u05dd') : '\u05d9\u05e9 \u05dc\u05da \u05de\u05e9\u05dc\u05d5\u05d7 \u05d0\u05e7\u05e1\u05e4\u05e8\u05e1 \u05d7\u05d9\u05e0\u05dd!';
    var ship='<div class="ship"><p>'+note+'</p><div class="ship-bar"><span style="width:'+pct+'%"></span></div></div>';
    if(!cart.items||!cart.items.length){
      body.innerHTML=ship+'<p>\u05d4\u05e2\u05d2\u05dc\u05d4 \u05e8\u05d9\u05e7\u05d4.</p>';
      return;
    }
    body.innerHTML=ship+cart.items.map(function(item){
      return "<div class='line'><img src='"+(item.image||'')+"' alt=''><div><strong>"+item.product_title+"</strong><p class='muted'>"+(item.variant_title||'')+"</p>"+priceHtml(item)+"<button type='button' data-remove='"+item.key+"' style='border:0;background:none;padding:0;margin-top:6px;text-decoration:underline;font-size:13px'>\u05d4\u05e1\u05d9\u05e8\u05d9</button></div></div>";
    }).join('');
  }
  function ensure(items){
    var handles=[];
    (items||[]).forEach(function(item){
      if(compareCache[item.handle]==null && handles.indexOf(item.handle)===-1) handles.push(item.handle);
    });
    if(!handles.length) return Promise.resolve();
    return Promise.all(handles.map(function(h){
      return fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.json();}).then(function(p){
        var map={};
        (p.variants||[]).forEach(function(v){ map[v.id]=v.compare_at_price||0; });
        compareCache[h]=map;
      }).catch(function(){ compareCache[h]={}; });
    }));
  }
  function paint(cart){
    var gen=++paintGen;
    render(cart);
    ensure(cart.items).then(function(){
      if(gen!==paintGen) return;
      render(cart);
    });
  }
  function openCart(){
    if(drawer) drawer.hidden=false;
    if(shade) shade.hidden=false;
    fetch('/cart.js').then(function(r){return r.json();}).then(paint);
  }
  function closeCart(){ if(drawer) drawer.hidden=true; if(shade) shade.hidden=true; }
  window.samOpenCart=openCart;
  if(bag) bag.addEventListener('click',function(e){e.preventDefault(); openCart();});
  document.querySelectorAll('[data-close-cart]').forEach(function(el){el.addEventListener('click',closeCart);});
  if(body) body.addEventListener('click',function(e){
    var btn=e.target.closest('[data-remove]');
    if(!btn) return;
    btn.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:btn.getAttribute('data-remove'),quantity:0})})
      .then(function(r){return r.json();}).then(paint);
  });
})();
